import { modifyMediaUrl } from "../../helpers/modifyMediaUrl";

const TrainerDetailInformation = ({
  trainer = {},
  translations,
}) => {
  return (
    <div className="trainer-detail-information-wrapper">
      <div className="flex justify-content-center">
        <div className='introduction-video-container w-full lg:w-11 flex justify-content-center mt-1'>
          <iframe
            src={trainer.introductionVideoURL ? modifyMediaUrl(trainer.introductionVideoURL) : ""}
            title={trainer.introductionVideoTitle}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
      </div>
      <div className='mt-3'>{translations.tutorIntroductionTitleLabel}</div>
      <div className='tutor-detail-title keduall-input mt-1 p-3'>
        {trainer.introductionVideoTitle ?? translations.unknownLabel}
      </div>
      <div className='mt-3'>{translations.tutorIntroductionTitleContentLabel}</div>
      <div className='tutor-detail-description keduall-input mt-1 p-3'>
        {trainer.introductionVideoDescription ? <HtmlDisplayComponent htmlContent={trainer.introductionVideoDescription} /> : translations.unknownLabel}
      </div>
    </div >
  );
}

const HtmlDisplayComponent = ({ htmlContent }) => {
  return (
    <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
  );
}

export default TrainerDetailInformation;
